import Icon from '../icon/Icon';
import Tooltip from '../tooltip/Tooltip';

import theme from '../../../themes/colors';

interface LabelProps {
  label: string;
  optionalText?: string;
  tooltipText?: string;
  className?: string;
  tooltipId?: string;
  tooltipStyle?: string;
  isRequired?: boolean;
  type?: 'default' | 'hasSubtext';
}

const Label = (props: LabelProps) => {
  const {
    label,
    optionalText,
    tooltipText,
    className,
    tooltipId,
    tooltipStyle,
    isRequired,
    type = 'default'
  } = props;

  return (
    <>
      {type === 'default' && (
        <div
          className={`mb-4 flex items-center gap-2 text-sm font-semibold text-grey ${className}`}
        >
          <div>
            {label}
            <span className="ml-1 text-grey60">{optionalText}</span>
            {isRequired && <span className="text-error">*</span>}
          </div>
          {tooltipText && (
            <>
              <Icon
                name="alert-circle"
                stroke={theme.subText}
                data-tooltip-id={`${tooltipId}-label-tooltip`}
              />
              <Tooltip
                id={`${tooltipId}-label-tooltip`}
                type="text"
                tooltipText={tooltipText}
                className={tooltipStyle}
              />
            </>
          )}
        </div>
      )}
      {type === 'hasSubtext' && (
        <>
          <div className="text-sm font-semibold text-grey">{label}</div>
          <div className="my-2 flex items-center gap-1 text-xs text-grey60">
            <Icon name="alert-circle" stroke={theme.subText} size="none" />
            {tooltipText}
          </div>
        </>
      )}
    </>
  );
};

export default Label;
